import { render, staticRenderFns } from "./SendReceiptsSMS.vue?vue&type=template&id=1fa418bb&scoped=true"
import script from "./SendReceiptsSMS.vue?vue&type=script&lang=js"
export * from "./SendReceiptsSMS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa418bb",
  null
  
)

export default component.exports